export enum LayoutTypes {
  HANDLE_CONTENT_WIDTH = 'HANDLE_CONTENT_WIDTH',
  HANDLE_MENU_COLLAPSED = 'HANDLE_MENU_COLLAPSED',
  HANDLE_MENU_HIDDEN = 'HANDLE_MENU_HIDDEN',
  HANDLE_RTL = 'HANDLE_RTL',
  LOGOUT = 'LOGOUT'
}